<script setup>
const props = defineProps({
  slide: {
    type: Object,
    required: true,
  },
  size: {
    type: String,
    default: 'large',
    validator(value) {
      return ['large', 'medium', 'small'].includes(value)
    },
  },
})
</script>

<template>
  <div class="slide d-flex flex-column">
    <Quotation
      class="slide__quotation"
      :text="props.slide.quotation"
      :size="size"
    />
    <div class="slide__author">
      <NuxtImg
        sizes="sm:340px md:440px lg:860px"
        densities="1x 2x"
        :src="props.slide.image?.src"
        :alt="props.slide.image?.alt"
        class="slide__image"
        loading="lazy"
        :placeholder="[300, 200, 60, 2]"
      />
      <div class="equal-base equal-base--tighter-bold-uppercase">
        {{ props.slide.name }}
      </div>
      <div class="equal-base equal-base--tighter slide__info">
        {{ props.slide.info }}
      </div>
      <ul
        v-if="props.slide.achievements"
        class="slide__achievements"
      >
        <li
          v-for="(achievement, index) in props.slide.achievements"
          :key="index"
        >
          {{ achievement }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.slide {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: $color-dark-02;
  border-radius: 12px;
  padding: 40px 50px 35px 50px;
  text-align: left;

  &__quotation {
    margin-bottom: 20px;
  }

  &__author {
    margin-top: auto;
  }

  &__image {
    width: clamp(80px, 4.17vw + 66.67px, 140px);
    height: clamp(80px, 4.17vw + 66.67px, 140px);
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 25px;

    @include media-breakpoint-down(560) {
      margin-bottom: 20px;
    }
  }

  &__info {
    margin-top: 10px;
  }

  &__achievements {
    margin-top: 15px;
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
    display: flex;
    color: #999999;
    flex-wrap: wrap;
    row-gap: 10px;

    li:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>
